module.exports = __webpack_public_path__ + "static/media/Lato-Bold.85d339d9.ttf";